<template>
  <div class="document-template" :style="{ height: list && list.length ? 'auto' : '100%' }">
    <div class="search-box-page">
      <div class="search-item">
        <div class="search-content">
          <el-input class="input-v2 input-round" v-model="queryParams.name" :placeholder="$t('documentName')" suffix-icon="el-icon-search" clearable @change="getData" />
        </div>
      </div>
    </div>
    <div class="data-list" v-if="list && list.length">
      <el-card class="data-item pointer" :body-style="{ padding: '0px' }" v-for="item in list" :key="item.name" @click.native="handleDownload(item)">
        <el-image class="document-icon" :src="documentIcon" fit="cover"></el-image>
        <div class="document-title">
          <p>{{ item.name | ignoreFileExtension }}</p>
          <p>模板</p>
        </div>
      </el-card>
    </div>
    <div style="height: calc(100% - 80px);" v-else>
      <bsp-empty style="height: 100%;"></bsp-empty>
    </div>
  </div>
</template>

<script>
  import documentIcon from '@/assets/img/policy/document-icon.png';
  import * as api from '@/api/policy/policyLibrary';
  export default {
    name: "DocumentTemplate",
    data() {
      return {
        documentIcon,
        queryParams:{
          name: ''
        },
        loading: false,
        list: []
      }
    },
    created() {
      this.getData();
    },
    methods: {
      // 点击模板下载
      handleDownload(val) {
        window.open(val.link);
      },
      // 获取列表
      getData() {
        this.loading = true;
        let params = {
          ...this.queryParams
        }
        api.businessDocuments(params)
          .then(res => {
            this.loading = false;
            this.list = res.data.data;
          })
          .catch(error => {
            this.loading = false;
          })
      }
    }
  }
</script>

